<template>
  <div class="acc-tabs-bar">
    <div class="acc-tabs">

      <router-link
        v-if="permission?.view_ledger_group == 1"
        :to="$url('/accounting/dashboard')"
        class="acc-tab"
        :class="isActive(['Accounting Dashboard']) ? 'acc-tab--active' : ''"
      >
        <font-awesome-icon icon="chart-pie" class="tab-icon" />
        Dashboard
      </router-link>

      <router-link
        v-if="permission?.view_ledger_group == 1"
        :to="$url('/manage-journals')"
        class="acc-tab"
        :class="isActive(['Manage Journals']) ? 'acc-tab--active' : ''"
      >
        <font-awesome-icon icon="book" class="tab-icon" />
        Manage Journals
      </router-link>

      <router-link
        v-if="permission?.view_ledger_group == 1"
        :to="$url('/journal-entries')"
        class="acc-tab"
        :class="isActive(['Journal Entries']) ? 'acc-tab--active' : ''"
      >
        <font-awesome-icon icon="file-alt" class="tab-icon" />
        Journal Entries
      </router-link>

      <router-link
        v-if="permission?.view_ledger_group == 1"
        :to="$url('/manage-ledgers')"
        class="acc-tab"
        :class="isActive(['Manage Ledgers']) ? 'acc-tab--active' : ''"
      >
        <font-awesome-icon icon="layer-group" class="tab-icon" />
        Ledger Accounts
      </router-link>

      <router-link
        v-if="permission?.view_transaction == 1"
        :to="$url('/transactions')"
        class="acc-tab"
        :class="isActive(['Transactions', 'Transaction Detail']) ? 'acc-tab--active' : ''"
      >
        <font-awesome-icon icon="exchange-alt" class="tab-icon" />
        All Transactions
      </router-link>

      <router-link
        v-if="permission?.view_ledger_group == 1 || permission?.view_po_payments == 1"
        :to="$url('/accounting/vendor-payments')"
        class="acc-tab"
        :class="isActive(['Vendor Payments']) ? 'acc-tab--active' : ''"
      >
        <font-awesome-icon icon="file-invoice-dollar" class="tab-icon" />
        Vendor Payments
      </router-link>

      <!-- <router-link
        v-if="permission?.view_ledger_group == 1"
        :to="$url('/accounting/payment-vouchers')"
        class="acc-tab"
        :class="isActive(['Payment Vouchers']) ? 'acc-tab--active' : ''"
      >
        <font-awesome-icon icon="receipt" class="tab-icon" />
        Payment Vouchers
      </router-link>

      <router-link
        v-if="permission?.view_ledger_group == 1"
        :to="$url('/accounting/bills')"
        class="acc-tab"
        :class="isActive(['Bills']) ? 'acc-tab--active' : ''"
      >
        <font-awesome-icon icon="file-alt" class="tab-icon" />
        Bills
      </router-link>

      <router-link
        v-if="permission?.view_ledger_group == 1"
        :to="$url('/accounting/petty-cash')"
        class="acc-tab"
        :class="isActive(['Petty Cash']) ? 'acc-tab--active' : ''"
      >
        <font-awesome-icon icon="coins" class="tab-icon" />
        Petty Cash
      </router-link> -->

      <router-link
        v-if="permission?.view_ledger_group == 1"
        :to="$url('/accounting/bank-accounts-setup')"
        class="acc-tab"
        :class="isActive(['Bank Accounts Setup']) ? 'acc-tab--active' : ''"
      >
        <font-awesome-icon icon="university" class="tab-icon" />
        Bank Accounts
      </router-link>

      <router-link
        v-if="permission?.view_ledger_group == 1"
        :to="$url('/accounting/fiscal-years')"
        class="acc-tab"
        :class="isActive(['Fiscal Years']) ? 'acc-tab--active' : ''"
      >
        <font-awesome-icon icon="calendar-alt" class="tab-icon" />
        Fiscal Years
      </router-link>

      <router-link
        :to="$url('/balance-sheet-report')"
        class="acc-tab"
        :class="isActive(['Balance Sheet Report']) ? 'acc-tab--active' : ''"
      >
        <font-awesome-icon icon="chart-bar" class="tab-icon" />
        Reports
      </router-link>

    </div>
  </div>
</template>

<script>
import { computed } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default {
  setup() {
    const store      = useStore();
    const router     = useRouter();
    const permission = computed(() => store.state.getCurrentUserPermission);
    const isActive   = (names) => names.includes(router.currentRoute.value.name);
    return { permission, isActive };
  },
};
</script>

<style scoped>
.acc-tabs-bar {
  background: #fff;
  border-bottom: 1px solid #e4eaf2;
  padding: 0 20px;
  margin-bottom: 20px;
}

.acc-tabs {
  display: flex;
  align-items: center;
  gap: 2px;
  overflow-x: auto;
  scrollbar-width: none;
}
.acc-tabs::-webkit-scrollbar { display: none; }

.acc-tab {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 13px 16px;
  font-size: 13.5px;
  font-weight: 500;
  color: #7a90b0;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;
  margin-bottom: -1px;
  cursor: pointer;
}
.acc-tab:hover { color: #004AAD; text-decoration: none; }

.acc-tab--active {
  color: #004AAD !important;
  border-bottom-color: #004AAD !important;
  font-weight: 600;
}

.tab-icon { font-size: 13px; opacity: 0.85; }

@media (max-width: 576px) {
  .acc-tabs-bar { padding: 0 12px; }
  .acc-tab      { padding: 11px 12px; font-size: 13px; }
}
</style>